import React from 'react';
import PrintButton from '../../../ui-components/Button/PrintButton';
import { withStyles, StyledComponentProps } from '@material-ui/core';

interface IProps extends StyledComponentProps {
    print: () => any;
    download: () => any;
}
const styles = {
    container: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '10px'
    }
}
const Comp = (props: IProps) => {
    return (<div className={props.classes.container}>
        <PrintButton onClick={props.print} />
        {/* <DownloadButton onClick={props.download} /> */}
    </div>)
}

export const Export = withStyles(styles)(Comp) 